import moment from 'moment-timezone';
import { getIntegerFromTimeInterval, getRegExpMatchArrayFromTimeInterval, } from 'components/settings/components/sections/openingHours/views/schedule/utils/validate';
/* This represents the time: "21:30" */
const maxEndInt = 2130;
const timeFormat = 'HH:mm';
export function getNewIntervals({ end: previousEnd }) {
    const defaultTime = {
        start: '22:45',
        end: '23:45',
    };
    if (!previousEnd)
        return defaultTime;
    const previousEndInt = getIntegerFromTimeInterval(previousEnd);
    const today = moment().startOf('day');
    const [hour, minute] = getRegExpMatchArrayFromTimeInterval(previousEnd);
    return previousEndInt > maxEndInt
        ? defaultTime
        : {
            start: today
                .clone()
                .add(parseInt(hour) + 1, 'hours')
                .add(parseInt(minute), 'minutes')
                .format(timeFormat),
            end: today
                .clone()
                .add(parseInt(hour) + 2, 'hours')
                .add(parseInt(minute), 'minutes')
                .format(timeFormat),
        };
}
